// 2026-05-26 - FormuLearning - Step 3 §3.6 시험약 결과 (업로드 + 용출 그리드)
// 2026-07-20 수정 - 이슈 #42: 용출 프로파일을 읽기 전용 나열 → 편집·저장 가능한 그리드로 전환.
// 2026-07-21 수정 - 이슈 #43: 배치 표·용출 그리드를 통합표(IntegrationTable)로 일원화.
//                   init 배치가 통합표에 들어오면서 이 자리의 표·그리드는 완전 중복이 되었고,
//                   `R01`·`B02` 두 갈래 표기도 여기서 나왔다(BR-LOT-01 배치 식별자 단일화).
// 2026-07-23 수정 - 이슈 #50: 다운로드 2종으로 재편 — 공양식(프로젝트 정보+빈 프로파일 표)·
//                   현재 프로파일(배치 수만큼 표 반복). 일괄 업로드 버튼은 유지(동작 기존 그대로).
// 2026-08-31 수정 - 이슈 #58 S5 5차(#68, M84-75): **엑셀 진입점 정리 — 내보내기 하나만 남긴다.**
//                   `Download Template (.xlsx)` 과 `Upload Results (all batches)` 를 걷고
//                   `Download Current Profiles (.xlsx)` 만 존치한다(사용자 결정 260831).
//                   ⚠️ **일괄 입력 경로가 사라진다** — 붙여넣기는 배치 하나씩이므로 배치가
//                   N개면 N번이다. 사용자가 이 점을 알고 채택했다(정본에 기록).
//                   백엔드 파서·양식 생성 엔드포인트는 남는다 — 화면 진입점만 걷는다.
// 2026-08-14 이동 - 이슈 #60(M84-71): 렌더 소관이 Step 4(`Step4Card.tsx`)인데 파일만
//                   `features/step3/`에 남아 있어 소재가 오해를 불렀다. 소관에 맞게 이동.
//                   순수 이동이며 동작 변경 없음.
// 파일 위치: frontend/src/features/step4/TestResultSection.tsx

import { useState } from 'react'

interface Props {
  /** 활성 Lot의 init 배치 수 — 안내 문구용. 표시는 통합표가 담당한다. */
  batchCount: number
  onDownloadProfiles: () => Promise<void>
}

export default function TestResultSection({ batchCount, onDownloadProfiles }: Props) {
  const [downloading, setDownloading] = useState(false)

  const download = async () => {
    setDownloading(true)
    try {
      await onDownloadProfiles()
    } finally {
      setDownloading(false)
    }
  }

  return (
    <div className="mb-4">
      <h4 className="mb-2 text-xs font-semibold uppercase tracking-wider text-text-secondary">
        Sample Test Results
      </h4>
      <div className="rounded border p-3" style={{ borderColor: 'var(--border-subtle)' }}>
        <div className="flex flex-wrap items-center gap-3">
          <button
            onClick={() => void download()}
            disabled={downloading}
            className="rounded px-3 py-1.5 text-[11px] font-medium text-accent-teal transition-colors hover:bg-bg-input disabled:opacity-50"
            style={{ border: '1px solid var(--border-teal)' }}
            data-testid="download-profiles"
          >
            {downloading ? 'Preparing...' : 'Download Current Profiles (.xlsx)'}
          </button>
          <span className="text-[10px] text-text-muted">
            {batchCount === 0
              ? 'Generate runs first.'
              : '조성·결과·용출 입력은 아래 통합표에서 직접 입력하거나 엑셀 범위를 붙여넣으십시오.'}
          </span>
        </div>
      </div>
    </div>
  )
}
